<template>
  <div id="top_nav" :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="routerPath"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="horizontal"
      >
        <sidebar-item
          v-for="route in menu"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
    <el-input
      style="width: 240px"
      placeholder="请输入内容"
      prefix-icon="el-icon-search"
      v-model="keyword"
      @keydown.enter.native="onKeydown"
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="onKeydown"
      ></el-button>
    </el-input>
    <Navbar />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import Navbar from "../Navbar";
import variables from "@/styles/variables.scss";
import { optAccess } from '@/utils/index'

export default {
  data() {
    return {
      keyword: "",
    };
  },

  components: {
    SidebarItem,
    Logo,
    Navbar,
  },
  computed: {
    ...mapGetters(['userInfo',"permission_routes", "sidebar"]),
    routerPath() {
      return this.$route.meta.guidePath
        ? this.$route.meta.jumpPath
        : this.$route.path;
    },
    menu() {
      return this.permission_routes.filter(item => {
        return optAccess(this.userInfo) || !['样板管理','意见单'].includes(item?.meta?.title)
      })
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  mounted() {
    console.log('this.$store.getters.permission_routes', this.$store.getters.permission_routes)
    this.onScroll();
  },
  methods: {
    optAccess,
    onKeydown() {
      this.$router.push({
        path: `/search?keyword=${this.keyword}`,
      });
    },
    onScroll() {
      window.onscroll = function () {
        var left =
          document.documentElement.scrollLeft || document.body.scrollLeft;
        document.getElementById("top_nav").style.left = -left + "px";
      };
    },
  },
};
</script>

<style scoped="">
.el-menu--horizontal {
  display: flex;
  align-items: center;
}

/* 一级菜单的样式 */
.el-menu--horizontal /deep/.el-menu-item {
  height: 60px;
  line-height: 60px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
}

/* 解决下图1 下拉三角图标 */
.el-menu--horizontal /deep/ .el-submenu .el-submenu__icon-arrow {
  position: static;
  vertical-align: middle;
  margin-left: 8px;
  margin-top: -3px;
}

/* 解决下图2 无下拉菜单时 不对齐问题 */
.el-menu--horizontal /deep/ .el-submenu__title {
  height: 60px;
  line-height: 60px;
  border-bottom: 2px solid transparent;
  color: #909399;
  margin-top: -4px;
}

.el-menu--horizontal /deep/ div {
  height: 60px;
  overflow: hidden;
}
</style>
